<template>
  <div
    class="flex flex-col md:flex-row items-center md:items-stretch w-full text-white rounded-lg shadow-md overflow-hidden ring-1 ring-white tracking-wider"
  >
    <!-- Logo e lutadores -->
    <div
      class="flex flex-col justify-between md:flex-row md:items-center w-full md:w-[65%] p-4"
    >
      <!-- Logo -->
      <div class="flex justify-center md:justify-start mb-4 md:mb-0 md:mr-6">
        <img
          :src="appLogo"
          alt="CombateOne"
          class="h-10 my-5 md:h-10"
        />
      </div>

      <!-- banner -->
      <div>
        <div class="flex justify-center items-center gap-2">
          <img
            :src="image"
            alt="Lutador 1"
            class="h-36 md:h-56 object-contain"
            width="300"
            height="144"
          />
        </div>
      </div>
    </div>

    <!-- Detalhes e botão -->
    <div
      class="flex flex-col justify-center md:justify-between text-center md:text-left w-full md:w-[35%] p-4 border-t md:border-t-0 md:border-l border-gray-200"
    >
      <div class="mb-4">
        <h3 class="text-2xl font-bold text-white uppercase">
          {{ title }}
        </h3>
        <p class="text-base text-white font-semibold tracking-widest">
          {{ date }}
        </p>
        <p class="text-xs text-gray-500 font-inter tracking-normal mt-2">
          {{ location }}
        </p>
        <p class="text-xs text-gray-500 font-inter tracking-normal mt-2">
          {{ desc }}
        </p>
      </div>

      <!-- Botão -->
      <slot />
    </div>
  </div>
</template>

<script setup>
import { dataShared } from '@/shared/store'
import { computed } from 'vue'

const appLogo = computed(() => dataShared.getters.getAppLogo)
const isMobile = computed(() => window.innerWidth < 1030)
const props = defineProps({
  image: {
    type: String,
    required: false
  },
  title: {
    type: String,
    default: 'Título do Evento'
  },
  date: {
    type: String,
    default: ''
  },
  amount: {
    type: Boolean,
    default: false
  },
  location: {
    type: String,
    required: false
  },
  desc: {
    type: String,
    required: false
  }
})
</script>
